import { Component, HostListener, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-grouped-bar',
  templateUrl: './grouped-bar.component.html',
  styleUrls: ['./grouped-bar.component.css']
})
export class GroupedBarComponent implements OnInit, OnChanges {
  
  @Input() groupedBarChartData: any;
  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._plotGroupedBar();
      // this.chartOption?.resize();
    }, 1);
  }
  chartOption: any;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.groupedBarChartData) { 
      this._plotGroupedBar();
    }
  }

  private _plotGroupedBar() {
    this.chartOption = {
      legend: {
        top: this.groupedBarChartData?.legendPosition ? this.groupedBarChartData?.legendPosition : 'top',
        icon: 'roundRect',
        padding: [0, 0, 50, 0],
        itemHeight: this.groupedBarChartData?.legendHeight ? this.groupedBarChartData?.legendHeight : 5,
        itemWidth: this.groupedBarChartData?.legendWidth ? this.groupedBarChartData?.legendWidth : 19,
        textStyle: {
          fontSize: 16,
          fontFamily: 'Inter',
          fontWeight: 500
        },
        itemGap: 60
      },
      color: this.groupedBarChartData?.color,
      tooltip: {},
      dataset: {
        source: this.groupedBarChartData?.groupedBarData
      },
      grid: {
        left: '3%',
        right: '3%',
        top: '10%'
      },
      xAxis: {
        type: 'category',
        name: this.groupedBarChartData?.xAxisLabel ? this.groupedBarChartData?.xAxisLabel : '',
        nameLocation: this.groupedBarChartData?.xNameLocation ? this.groupedBarChartData?.xNameLocation : 'middle',
        nameTextStyle: {
          fontFamily: 'Inter',
          fontSize: 12,
          fontWeight: 400,
          color: '#9291A5',
          padding: [20, 0, 0, 0]
        },
        axisTick: {
          show: this.groupedBarChartData?.xAxisTick ? this.groupedBarChartData?.xAxisTick : false
        },
        splitLine: {
          show: true, // Show grid lines
        },
        // nameGap: 40
      },
      yAxis: {
        name: this.groupedBarChartData?.yAxisLabel ? this.groupedBarChartData?.yAxisLabel : '',
        nameLocation: this.groupedBarChartData?.yNameLocation ? this.groupedBarChartData?.yNameLocation : 'middle',
        nameTextStyle: {
          fontFamily: 'Inter',
          fontSize: 12,
          fontWeight: 400,
          color: '#9291A5'
        },
        axisTick: {
          show: this.groupedBarChartData?.yAxisTick ? this.groupedBarChartData?.yAxisTick : false
        },
        axisLabel: {
          show: !this.groupedBarChartData?.yaxisLabelShow ? false : true
        },
        splitLine: {
          show: true, // Show grid lines
        },
      },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [{ type: 'bar', barWidth: this.groupedBarChartData?.barWidth ? this.groupedBarChartData?.barWidth : null },
      { type: 'bar', barWidth: this.groupedBarChartData?.barWidth ? this.groupedBarChartData?.barWidth : null },
      { type: 'bar', barWidth: this.groupedBarChartData?.barWidth ? this.groupedBarChartData?.barWidth : null },
      { type: 'bar', barWidth: this.groupedBarChartData?.barWidth ? this.groupedBarChartData?.barWidth : null },
      { type: 'bar', barWidth: this.groupedBarChartData?.barWidth ? this.groupedBarChartData?.barWidth : null }]
    };
  }
}
